// ISO-3166 Alpha-2 Ländercodes mit deutschem Namen und Flag-Emoji
// Sortiert alphabetisch nach deutschem Namen
const ce = (code) => String.fromCodePoint(...code.toUpperCase().split("").map(c => 0x1F1E6 + c.charCodeAt(0) - 65));

export const COUNTRIES = [
  { code: "EG", name: "Ägypten" },
  { code: "AL", name: "Albanien" },
  { code: "DZ", name: "Algerien" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AR", name: "Argentinien" },
  { code: "AM", name: "Armenien" },
  { code: "AZ", name: "Aserbaidschan" },
  { code: "ET", name: "Äthiopien" },
  { code: "AU", name: "Australien" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesch" },
  { code: "BE", name: "Belgien" },
  { code: "BO", name: "Bolivien" },
  { code: "BA", name: "Bosnien-Herzegowina" },
  { code: "BR", name: "Brasilien" },
  { code: "BG", name: "Bulgarien" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CR", name: "Costa Rica" },
  { code: "DK", name: "Dänemark" },
  { code: "DE", name: "Deutschland" },
  { code: "DO", name: "Dominikanische Republik" },
  { code: "EC", name: "Ecuador" },
  { code: "SV", name: "El Salvador" },
  { code: "EE", name: "Estland" },
  { code: "FJ", name: "Fidschi" },
  { code: "FI", name: "Finnland" },
  { code: "FR", name: "Frankreich" },
  { code: "GE", name: "Georgien" },
  { code: "GH", name: "Ghana" },
  { code: "GR", name: "Griechenland" },
  { code: "GT", name: "Guatemala" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hongkong" },
  { code: "IN", name: "Indien" },
  { code: "ID", name: "Indonesien" },
  { code: "IQ", name: "Irak" },
  { code: "IR", name: "Iran" },
  { code: "IE", name: "Irland" },
  { code: "IS", name: "Island" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italien" },
  { code: "JM", name: "Jamaika" },
  { code: "JP", name: "Japan" },
  { code: "YE", name: "Jemen" },
  { code: "JO", name: "Jordanien" },
  { code: "KH", name: "Kambodscha" },
  { code: "CM", name: "Kamerun" },
  { code: "CA", name: "Kanada" },
  { code: "KZ", name: "Kasachstan" },
  { code: "QA", name: "Katar" },
  { code: "KE", name: "Kenia" },
  { code: "CO", name: "Kolumbien" },
  { code: "HR", name: "Kroatien" },
  { code: "CU", name: "Kuba" },
  { code: "KW", name: "Kuwait" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Lettland" },
  { code: "LB", name: "Libanon" },
  { code: "LY", name: "Libyen" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Litauen" },
  { code: "LU", name: "Luxemburg" },
  { code: "MG", name: "Madagaskar" },
  { code: "MY", name: "Malaysia" },
  { code: "MT", name: "Malta" },
  { code: "MA", name: "Marokko" },
  { code: "MK", name: "Mazedonien" },
  { code: "MX", name: "Mexiko" },
  { code: "MD", name: "Moldau" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolei" },
  { code: "ME", name: "Montenegro" },
  { code: "MZ", name: "Mosambik" },
  { code: "NA", name: "Namibia" },
  { code: "NP", name: "Nepal" },
  { code: "NZ", name: "Neuseeland" },
  { code: "NI", name: "Nicaragua" },
  { code: "NL", name: "Niederlande" },
  { code: "NG", name: "Nigeria" },
  { code: "KP", name: "Nordkorea" },
  { code: "NO", name: "Norwegen" },
  { code: "OM", name: "Oman" },
  { code: "AT", name: "Österreich" },
  { code: "PK", name: "Pakistan" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua-Neuguinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippinen" },
  { code: "PL", name: "Polen" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "RW", name: "Ruanda" },
  { code: "RO", name: "Rumänien" },
  { code: "RU", name: "Russland" },
  { code: "SB", name: "Salomonen" },
  { code: "ZM", name: "Sambia" },
  { code: "SM", name: "San Marino" },
  { code: "SA", name: "Saudi-Arabien" },
  { code: "SE", name: "Schweden" },
  { code: "CH", name: "Schweiz" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbien" },
  { code: "SG", name: "Singapur" },
  { code: "SK", name: "Slowakei" },
  { code: "SI", name: "Slowenien" },
  { code: "SO", name: "Somalia" },
  { code: "ES", name: "Spanien" },
  { code: "LK", name: "Sri Lanka" },
  { code: "ZA", name: "Südafrika" },
  { code: "SD", name: "Sudan" },
  { code: "KR", name: "Südkorea" },
  { code: "SY", name: "Syrien" },
  { code: "TJ", name: "Tadschikistan" },
  { code: "TW", name: "Taiwan" },
  { code: "TZ", name: "Tansania" },
  { code: "TH", name: "Thailand" },
  { code: "TG", name: "Togo" },
  { code: "TT", name: "Trinidad und Tobago" },
  { code: "TD", name: "Tschad" },
  { code: "CZ", name: "Tschechien" },
  { code: "TN", name: "Tunesien" },
  { code: "TR", name: "Türkei" },
  { code: "TM", name: "Turkmenistan" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "HU", name: "Ungarn" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Usbekistan" },
  { code: "VE", name: "Venezuela" },
  { code: "AE", name: "Vereinigte Arabische Emirate" },
  { code: "US", name: "Vereinigte Staaten" },
  { code: "GB", name: "Vereinigtes Königreich" },
  { code: "VN", name: "Vietnam" },
  { code: "BY", name: "Weißrussland" },
  { code: "CF", name: "Zentralafrikanische Republik" },
  { code: "CY", name: "Zypern" },
];

// Flag-Emoji aus ISO-2 Code ableiten
export const flagFromCode = (code) => {
  if (!code || code.length !== 2) return "";
  try { return ce(code); } catch { return ""; }
};

// Lookup-Map: code -> name
export const COUNTRY_NAME_BY_CODE = Object.fromEntries(COUNTRIES.map(c => [c.code, c.name]));
